<!--
 * @Author: hfxie
 * @Date: 2021-01-01 17:10:10
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-11-07 08:56:24
 * @Description: 甘特图主体结构页面
-->
<template>
  <div
    class="gantt"
    :class="{'gantt-noTop': noTop}"
    :style="{
      '--linkline-color': $store.state.viewSchem.linkLineColor,
      '--border-color': $store.state.viewSchem.borderColor,
      '--borderX-color': $store.state.viewSchem.borderXColor,
      '--gantt-theme-color': $store.state.theme,
      '--gantt-row-height': $store.state.cellHeight + 'px',
      '--gantt-task-height': $store.state.taskHeight + 'px',
      '--gantt-timeline-height': $store.state.timesLineHeight + 'px',
      '--gantt-timeline-bg-color': $store.state.viewSchem.timelineBgDatesColor,

    }"
  >
    <!-- 左·任务表 -->
    <div
      v-show="$store.getters.noWBS !== true"
      class="wbs-box"
      :style="{ width: $store.getters.WBSLeft + 'px' }"
      ref="wbs"
    >
      <div class="wbs-main" :style="WBSStyle">
        <FormHeader :colsShow="colsShow"  v-if="!noTop"/>
        <!-- 基础区 -->
        <div class="common-panel pageData-panel">
          <FormBody
            :colsShow="colsShow"
            :rowsShow="rowsShow"
            :rowsShowMap="rowsShowMap"
            :ganttType="CONSTNAME.PLANS"
            ref="FormBody1"
            :reactVueComponent="$refs.Content1"
            :reactVueIndex="0"
            :estimatedItemSize="rowItemHeight"
            @setStartEnd="handlerSetStartEnd"
          />
        </div>
        <!-- 待分配区 -->
        <div
          v-if="$store.state.todoShow"
          class="common-panel todos-panel"
          :style="rowsShowHeight2"
        >
          <FormBody
            :colsShow="colsShow"
            :rowsShow="rowsShow2"
            :rowsShowMap="rowsShowMap2"
            :ganttType="CONSTNAME.TODOS"
            ref="FormBody2"
            :reactVueComponent="$refs.Content2"
            :reactVueIndex="1"
            :estimatedItemSize="rowItemHeight"
            @setStartEnd="handlerSetStartEnd"
          />
        </div>

        <!-- 统计区表头 -->
        <div
          v-if="$store.state.summaryShow"
          class="summary-panel"
          :style="{
            height: summaryHeight + 'px',
          }"
        >
          <SummaryHeader
            :summaryHeader="summaryHeader"
            ref="FormBody3"
            :reactVueComponent="$refs.Content3"
            :reactVueIndex="0"
          />
        </div>

      </div>
    </div>

    <!-- 拖拽条 -->
    <div
      class="wbs-dragLine"
      :style="{
        left: $store.getters.WBSLeft - 4 + 'px',
      }"
      @mousedown="ChangeTableWidth($event)"
      :data-html2canvas-ignore="$store.state.viewSchem.noGanttOutBoxBorder && ($store.getters.noWBS || $store.getters.noGantt)"
    ></div>

    <!-- 视图切换 -->
    <div
      class="gantt-show-option"
      :style="{
        'left': $store.getters.WBSLeft - 20 + 'px',
      }"
      @mousedown.stop="False"
      data-html2canvas-ignore
    >
      <div class="gantt-show-option-left" @click.stop="Show('left')">
        <i class="kdfont kdfont-left kd-hover-color"></i>
      </div>
      <div class="gantt-show-option-right" @click.stop="Show('right')">
        <i class="kdfont kdfont-right kd-hover-color"></i>
      </div>
    </div>

    <!-- 右·甘特图 -->
    <div
      v-if="$store.getters.noGantt !== true"
      class="gantt-box"
      ref="scrollTaskWrapper"
      :style="ganttBoxStyle"
    >
      <div class="gantt-main" :style="timesTotalStyle">
        <Header v-if="!noTop" />
        <!-- 基础区 -->
        <div
          :class="ganttOutboxBorderClass"
          class="common-panel pageData-panel"
        >
          <Content
            :rowsShow="rowsShow"
            :emptyBars="emptyBars"
            :barsArr="barsArr"
            :yLines="rowsShowYLines"
            :rowsShowMap="rowsShowMap"
            :ganttType="CONSTNAME.PLANS"
            ref="Content1"
            :reactVueComponent="$refs.FormBody1"
            :reactVueIndex="0"
            :estimatedItemSize="rowItemHeight"
          />
        </div>
        <!-- 待分配区 -->
        <div
          v-if="$store.state.todoShow"
          :class="ganttOutboxBorderClass"
          class="common-panel todos-panel"
          :style="rowsShowHeight2"
        >
          <Content
            :rowsShow="rowsShow2"
            :barsArr="barsArr2"
            :yLines="rowsShowYLines2"
            :rowsShowMap="rowsShowMap2"
            :ganttType="CONSTNAME.TODOS"
            ref="Content2"
            :reactVueComponent="$refs.FormBody2"
            :reactVueIndex="1"
            :estimatedItemSize="rowItemHeight"
          />

        </div>
        <!-- 统计区 -->
        <div
          v-if="$store.state.summaryShow"
          :class="ganttOutboxBorderClass"
          class="summary-panel"
          :style="{
            height: summaryHeight + 'px',
          }"
        >
          <ContentForm
            :summaryBody="summaryBody"
            ref="Content3"
            :reactVueComponent="$refs.FormBody3"
            :reactVueIndex="2"
          />
        </div>
        <!-- 拖拽指引线 -->
        <YAxis v-if="$store.state.guideYAxis && $store.state.guideYAxis.isShow" v-bind="$store.state.guideYAxis" />
      </div>
    </div>

  </div>
</template>

<script>
import FormHeader from "./WBS/FormHeader/FormHeader";
import FormBody from "./WBS/FormBody/FormBody";
import Header from "./Header/Header";
import Content from "./Content/Content";

import ContentForm from "./Content/ContentForm/ContentForm.vue";
import SummaryHeader from "./WBS/SummaryHeader/SummaryHeader.vue";
import YAxis from "@/components/Gantt/Content/YAxis/YAxis";

import CONSTNAME from "@/ConstName.js";
export default {
  name: "Gantt",
  data() {
    return {
      count: 0,
      CONSTNAME: CONSTNAME,
      [CONSTNAME.PLANS]: {
        taskStartIndex: 0,
        taskEndIndex: this.$store.state.minRowsNum * 2,
      },
      [CONSTNAME.TODOS]: {
        taskStartIndex: 0,
        taskEndIndex: this.$store.state.minRowsNum * 2,
      },
    };
  },
  props: {
    noTop: {
      type: Boolean,
      default: false,
    },
  },
  provide: {
    CONSTNAME,
  },
  components: {
    FormHeader,
    FormBody,
    Header,
    Content,
    ContentForm,
    SummaryHeader,
    YAxis,
  },
  computed: {
    WBSWidth() {
      const result = this.$store.getters.wbsContentWidth;
      if (
        result < this.$store.getters.WBSLeft
      ) {
        return -1; // 无右侧视图且内容少于总占宽 this.$store.getters.noGantt &&
      }
      return result;
    },
    WBSStyle() {
      const _self = this;
      if (_self.WBSWidth < 0) return;
      const result = {
        width: `${_self.WBSWidth}px`,
      };
      return result;
    },
    ganttBoxStyle() {
      let _ganttWidth;
      const _wbsWidth = this.$store.getters.WBSLeft;
      let _ganttBoxWidth;
      if (
        this.$store.getters.printViewChangeFlag
      ) {
        _ganttBoxWidth = this.$store.getters.timesTotalWidth;
      } else {
        _ganttWidth = this.$store.getters.ganttWidth;
        _ganttBoxWidth = _ganttWidth - _wbsWidth;
      }
      const reuslt = {
        left: _wbsWidth + "px",
        width: _ganttBoxWidth + "px",
      };
      return reuslt;
    },
    timesTotalStyle() {
      const _width = this.$store.getters.timesTotalWidth;
      if (_width > 0) {
        return `width: ${_width}px;`;
      } else {
        return "width: auto;";
      }
    },
    ganttOutboxBorderClass(){
      return {
        'gantt-outbox-border': (!this.$store.state.viewSchem.noGanttOutBoxBorder),
      }
    },
    // 每行预估高度
    rowItemHeight() {
      return this.$store.state.cellHeight;
    },
    // 基础计划·左侧表栏显示列
    colsShow() {
      const arr = this.$store.state.wbsHeaderArr.filter((a, index) => {
        if (a.visible) {
          a.sourceIndex = index;
        }
        return a.visible;
      });
      return arr;
    },
    // 基础计划·左侧表单
    rowsShow() {
      const list1 = this.$store.state[CONSTNAME.PLANS + "_wbsRowArr"];
      return list1;
    },
    // 基础计划·横道集合
    emptyBars() {
      let emptyBars1 = [];
      if (
        this.$store.state.viewSchem.emptyBarsShow === true &&
        this.$store.state[CONSTNAME.PLANS + "_emptyTasksArr"] instanceof Array
      ) {
        emptyBars1 = this.$store.state[CONSTNAME.PLANS + "_emptyTasksArr"];
      }
      return emptyBars1;
    },
    // 基础计划·横道集合
    barsArr() {
      if (this.$store.state.viewSchem.normalBarsShow !== true) {
        return [];
      }
      const bars1 = this.$store.state[CONSTNAME.PLANS + "_tasksArr"];
      if (
        this.rowsShow.length > this.$store.state.viewSchem.virtualStartNum &&
        !this.$store.state.printStatus &&
        !(this.$store.state.viewSchem.isPrintModeShow)
      ) {
        const barsShow = bars1.slice(this[CONSTNAME.PLANS].taskStartIndex, this[CONSTNAME.PLANS].taskEndIndex);
        return barsShow;
      }
      return bars1;
    },
    // 基础计划·垂直线集合
    rowsShowYLines() {
      const lines1 = this.$store.state[CONSTNAME.PLANS + "_yLines"];
      return lines1;
    },
    // 基础计划·行字典
    rowsShowMap() {
      const listMap1 = this.$store.state[CONSTNAME.PLANS + "_map"];
      return listMap1;
    },
    /* 待排区 */
    rowsShow2() {
      const list2 = this.$store.state[CONSTNAME.TODOS + "_wbsRowArr"];
      return list2;
    },
    barsArr2() {
      const bars2 = this.$store.state[CONSTNAME.TODOS + "_tasksArr"];
      if (
        this.rowsShow2.length > this.$store.state.viewSchem.virtualStartNum &&
        !this.$store.state.printStatus &&
        !(this.$store.state.viewSchem.isPrintModeShow)
      ) {
        const barsShow2 = bars2.slice(this[CONSTNAME.TODOS].taskStartIndex, this[CONSTNAME.TODOS].taskEndIndex);
        return barsShow2;
      }
      return bars2;
    },
    rowsShowHeight2() {
      return { height: this.$store.state[CONSTNAME.TODOS + "_rowsNum"] * this.$store.state.cellHeight + "px" };
    },
    rowsShowYLines2() {
      const lines2 = this.$store.state[CONSTNAME.TODOS + "_yLines"];
      return lines2;
    },
    rowsShowMap2() {
      const listMap2 = this.$store.state[CONSTNAME.TODOS + "_map"];
      return listMap2;
    },
    /* 统计区 */
    summaryHeader() {
      return this.$store.state[CONSTNAME.SUMMARY + "_header"];
    },
    summaryBody() {
      return this.$store.state[CONSTNAME.SUMMARY + "_body"];
    },
    summaryHeight() {
      return this.$store.state[CONSTNAME.SUMMARY + "_rowsNum"] * this.$store.state.summaryCellHeight + 1;
    },
  },
  methods: {
    // 调整WBS视口区域【鉴权】
    ChangeTableWidth(e) {
      const _self = this;
      _self.$store.state.showMode == "both" &&
      _self.$utils.getAuthentication(_self.$store.state.accessLevel, [1, 2]) &&
      (() => {
        const odivParent = _self.$refs.wbs; // e.currentTarget.parentNode; // 获取目标父元素
        const dx = e.clientX; // 第一次点击的时候，存储x轴的坐标。
        const dw = odivParent.offsetWidth; // 存储默认的div的宽度。
        const _uuid = _self.$store.state.uuid;
        const _obj = {

        }; // 后端缓存数据
        document.getElementById(_uuid).onmousemove = _self.$utils.throttle((e) => {
          let _tableWidth = dw + (e.clientX - dx);
          if (_tableWidth <= 50) {
            _tableWidth = 50;
          }
          const max = _self.$store.getters.wbsContentWidth;
          if (_tableWidth >= max) {
            _tableWidth = max;
          }
          _obj.width = _tableWidth;
          _self.$store.commit("setInitTableWidth", _tableWidth);
        }, 20, false);
        document.getElementById(_uuid).onmouseup = () => {
          if (_obj.width) {
            _self.$store.dispatch("_set_InitTableWidth", _obj);
          }
          document.getElementById(_uuid).onmousemove = null;
          document.getElementById(_uuid).onmouseup = null;
        };
        e.stopPropagation();
        e.preventDefault();
        return false;
      })();
    },
    // 视图切换
    False(e) {
      e.stopPropagation();
      e.preventDefault();
      return false;
    },
    // 视图切换【鉴权】
    Show(type) {
      const _self = this;
      _self.$utils.getAuthentication(_self.$store.state.accessLevel, [1, 2]) &&
      (() => {
        const oldShowMode = _self.$store.state.showMode;
        let newShowMode = "both";
        switch (oldShowMode) {
            case "left":
              if (type == "right") {
                return _self.$Message({
                  message: "无效操作",
                  type: "error",
                });
              }
              newShowMode = "both";
              setTimeout(() => {
                const _leftNodes = this.$refs.wbs.getElementsByClassName("scroll-list-container");
                const _rightNodes = this.$refs.scrollTaskWrapper.getElementsByClassName("gantt-content");
                for (let i = 0; i < _leftNodes.length; i++) {
                  const targetEl_left = _leftNodes[i];
                  const targetEl_right = _rightNodes[i];
                  targetEl_right.scrollTop = targetEl_left.scrollTop;
                }
              }, 10);
              break;
            case "right":
              if (type == "left") {
                return _self.$Message({
                  message: "无效操作",
                  type: "error",
                });
              }
              newShowMode = "both";
              setTimeout(() => {
                const _leftNodes = this.$refs.wbs.getElementsByClassName("scroll-list-container");
                const _rightNodes = this.$refs.scrollTaskWrapper.getElementsByClassName("gantt-content");
                for (let i = 0; i < _leftNodes.length; i++) {
                  const targetEl_left = _leftNodes[i];
                  const targetEl_right = _rightNodes[i];
                  targetEl_left.scrollTop = targetEl_right.scrollTop;
                }
              }, 10);
              break;
            case "both":
            default:
              if (type == "left") {
                newShowMode = "right";
              } else {
                newShowMode = "left";
              }
              break;
        }
        _self.$store.commit("changeShowMode", newShowMode);
        const info = { type };
        _self.$store.dispatch("_changeShowMode", info);
      })();
    },

    /* 虚拟列表·控制右侧横道数量 */
    handlerSetStartEnd(info) {
      const { ganttType, start, end } = info;
      const mapSource = this.$store.state[ganttType + "_map"];
      const wbsSource = this.$store.state[ganttType + "_wbsRowArr"];
      const taskStartIndex = (!start || start <= 0) ? mapSource[wbsSource[0].id].taskStartIndex : mapSource[wbsSource[start].id].taskStartIndex;
      let taskEndIndex;
      if (wbsSource[end] && end <= wbsSource.length) {
        taskEndIndex = mapSource[wbsSource[end].id]? mapSource[wbsSource[end].id].taskEndIndex: this[ganttType].taskEndIndex;
      } else {
        taskEndIndex = mapSource[wbsSource[wbsSource.length - 1].id]? mapSource[wbsSource[wbsSource.length - 1].id].taskEndIndex: this[ganttType].taskEndIndex;
      }
      if (
        this[ganttType].taskStartIndex === taskStartIndex &&
        this[ganttType].taskEndIndex === taskEndIndex
      ) {
        return;
      }
      this[ganttType] = {
        taskStartIndex,
        taskEndIndex,
      };
    },
  },
};
</script>

<style scoped lang='less'>
@import './Gantt.less';
</style>
